import angular from 'angular';
import sendEmail from './send-email/send-email';
import changePassword from './change-password/change-password';

const passwordReset = angular.module('passwordReset', [sendEmail, changePassword]);

export default passwordReset.name;
